import React from 'react';
import styled from 'styled-components';

import { ConditionalLink, Icons, Typography } from 'components';

const ButtonIcon = styled(Icons)`
  color: ${({ theme }) => theme.colors.primary_400};

  ${({ theme: { mediaQueries } }) => {
    return `
      width: 20px;

      ${mediaQueries.desktop} {
        width: 26px;
      }
    `;
  }}
`;

const ButtonLabel = styled(Typography)``;

const ButtonWrapper = styled(ConditionalLink)`
  border: 0;
  background: white;
  text-align: left;
  padding: 0;
  border-radius: 4px;
  position: relative;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-between;

  width: ${(props: any) => (props['data-full'] ? '100%' : 'inherit')};

  &:hover {
    background: ${({ theme }) => theme.colors.primary_400};

    ${ButtonLabel},
    ${ButtonIcon} {
      color: white;
    }
  }

  &:active {
    background: ${({ theme }) => theme.colors.primary_600};

    ${ButtonLabel},
    ${ButtonIcon} {
      color: white;
    }
  }

  ${(props: any) => {
    return `
      padding: ${props['data-size'] === 'large' ? '15px' : '10px'};

      ${props.theme.mediaQueries.desktop} {
        padding: ${props['data-size'] === 'large' ? '20px' : '8px'};
      }
    `;
  }}
`;

interface ProductsCertificateDownloadProps {
  filePath: string;
  size?: 'large' | 'small';
  full?: boolean;
}

const ProductsCertificateDownload = ({ size = 'large', full = false, filePath }: ProductsCertificateDownloadProps) => {
  return (
    <>
      <ButtonWrapper data-full={full} data-size={size} to={filePath} type="external" target="_blank">
        <ButtonLabel type={size === 'large' ? 'type3' : 'type2'} fontWeight="bold">
          Certificado de conclusão
        </ButtonLabel>

        <ButtonIcon icon="download" />
      </ButtonWrapper>
    </>
  );
};

export default ProductsCertificateDownload;
